import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "revico-community-talk-reply-details-nice-wrapper" }
const _hoisted_2 = { class: "revico-community-talk-reply-details-nice thanks" }
const _hoisted_3 = { class: "revico-community-talk-reply-details-nice disabled" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" いいね送付前のUI "),
    ($props.isPostable && !$props.isPosted)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "revico-community-talk-reply-details-nice postable",
          onClick: $setup.onclick
        }, [
          _createTextVNode(_toDisplayString($props.wordSettings?.likeButtonLabel) + " ", 1 /* TEXT */),
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-thumbs-up" }),
          _createTextVNode(" " + _toDisplayString($props.niceCount), 1 /* TEXT */)
        ]))
      : ($props.isPostable && $props.isPosted)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createCommentVNode(" いいね送付後のUI "),
            _createElementVNode("p", _hoisted_2, [
              _createTextVNode(_toDisplayString($props.wordSettings?.likePostedText) + " ", 1 /* TEXT */),
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-thumbs-up" })
            ])
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createCommentVNode(" いいね押下不可のUI "),
            _createElementVNode("p", _hoisted_3, [
              _createTextVNode(_toDisplayString($props.wordSettings?.likeButtonLabel) + " ", 1 /* TEXT */),
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-thumbs-up" }),
              _createTextVNode(" " + _toDisplayString($props.niceCount), 1 /* TEXT */)
            ])
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
  ]))
}